import { useMemo } from 'react';

import { HomeyUtils } from '../../../store/HomeyUtils.ts';

import { useDevice } from '../../../store/devices/useDevices.ts';
import { useApi } from '../../../store/SelectedHomeyStore.hooks.ts';

import styles from './DeviceSettingsMaintenance.module.css';

import { Heading3Bold } from '../../../components/common/text/Heading3Bold';

import { DeviceSettingsMaintenanceAction } from './DeviceSettingsMaintenanceAction';
import { DeviceSettingsMaintenanceFirmwareUpdate } from './DeviceSettingsMaintenanceFirmwareUpdate';

export function DeviceSettingsMaintenance(props) {
  const { homey } = useApi();
  const { device } = useDevice({
    deviceId: props.deviceId,
  });

  const maintenanceCapabilitiesList = useMemo(() => {
    return Object.values(device?.capabilitiesObj ?? {}).filter((capabilityObj) => {
      if (capabilityObj.id.startsWith('button') === false) {
        return false;
      }

      return (
        capabilityObj.maintenanceAction === true ||
        capabilityObj.options?.maintenanceAction === true
      );
    });
  }, [device?.capabilitiesObj]);

  const hasFirmwareUpdate =
    HomeyUtils.getHasDeviceUpdates(homey) === true && device?.firmwareUpdate != null;

  if ((maintenanceCapabilitiesList.length === 0 && hasFirmwareUpdate === false) || device == null) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Heading3Bold className={styles.heading}>Maintenance</Heading3Bold>

      {maintenanceCapabilitiesList.map((capability) => {
        return (
          <DeviceSettingsMaintenanceAction
            key={capability.id}
            capabilityId={capability.id}
            deviceId={device.id}
          />
        );
      })}

      {hasFirmwareUpdate === true && <DeviceSettingsMaintenanceFirmwareUpdate device={device} />}
    </div>
  );
}
